import {
  InvalidSessionError,
  TwoFactorAuthError,
} from "@tastyworks/tastyworks-api"

/*
Certain errors should be rethrown so each use of `tc` (and its derivatives) does not need to
remember to handle these scenarios:
  - InvalidSessionError is handled globally to redirect to /login
  - TwoFactorAuthError is caught by ChallengePrompt to prompt a user for their 2FA code
*/
export function rethrowIfHandledGlobally(e: unknown) {
  if (e instanceof InvalidSessionError || e instanceof TwoFactorAuthError) {
    throw e
  }
}
